<template>
    <div class="avatar-preview">
      <div class="overlay" v-if="!disabled">
        <label class="upload-file__btn" :disabled="disabled" @click.stop="">
          <svg class="photo-icon" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
            <circle class="photo-icon__circle" cx="15" cy="15" r="14.5"/>
            <path class="photo-icon__icon" d="M22 11.25V19.6071C22 20.3761 21.4121 21 20.6875 21H9.3125C8.58789 21 8 20.3761 8 19.6071V11.25C8 10.481 8.58789 9.85714 9.3125 9.85714H11.7188L12.0551 8.90246C12.2465 8.35982 12.7359 8 13.2828 8H16.7145C17.2613 8 17.7508 8.35982 17.9422 8.90246L18.2812 9.85714H20.6875C21.4121 9.85714 22 10.481 22 11.25ZM18.2812 15.4286C18.2812 13.5076 16.8102 11.9464 15 11.9464C13.1898 11.9464 11.7188 13.5076 11.7188 15.4286C11.7188 17.3496 13.1898 18.9107 15 18.9107C16.8102 18.9107 18.2812 17.3496 18.2812 15.4286ZM17.4062 15.4286C17.4062 16.8359 16.3262 17.9821 15 17.9821C13.6738 17.9821 12.5938 16.8359 12.5938 15.4286C12.5938 14.0212 13.6738 12.875 15 12.875C16.3262 12.875 17.4062 14.0212 17.4062 15.4286Z"/>
          </svg>
          <input type="file" class="upload-file__input" :disabled="disabled" accept="image/*" @change="selectFile">
        </label>
      </div>
      <img v-if="avatar !== null && avatar.file_size && !avatarPreview" :src="avatar.url" alt="Фото сотрудника">
      <img v-if="avatarPreview" :src="avatarPreview" alt="Фото сотрудника">
      <img v-else src="/img/svg/avatar__icon.svg" alt="Фото отсутствует">
    </div>
</template>

<script>
export default {
  name: 'app-input-avatar',
  props: {
    avatar: Object,
    title: String,
    tip: String,
    disabled: Boolean
  },
  data () {
    return {
      avatarPreview: ''
    }
  },
  methods: {
    selectFile (event) {
      const file = event.currentTarget.files[0]
      const reader = new FileReader()
      reader.addEventListener('load', function () {
        this.avatarPreview = reader.result
      }.bind(this), false)
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        }
      }
      this.$emit('value-changed', file)
    }
  }
}
</script>

<style lang="scss" scoped>

.photo-icon {
  fill: none;
  transition: .3s;

  &__circle {
    stroke: $color_main;
  }

  &__icon {
    fill: $color_main;
    transition: .3s;
  }
}

.overlay {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transition: .3s;
  background: transparentize($color_second, .3);
}

.avatar-preview {
  position: relative;
  @include size(100px);
  border-radius: 50%;
  overflow: hidden;

  img {
    object-fit: cover;
    width: 100%;
    height: auto;
    min-height: 100%;
  }

  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}

.upload-file {
  &__title {
    color: $font_color_second;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    max-width: 160px;
    height: 30px;
    font-size: 14px;
    color: $color_second-border2;
    transition: .3s;
    cursor: pointer;
    user-select: none;

    &:hover {
      .photo-icon {
        fill: $color_main;

        &__icon {
          fill: $color_second-light;
        }
      }
    }

    &[disabled] {
      pointer-events: none;
      cursor: auto;
      border: 1px solid $color_deactive;
      color: $color_deactive;
    }
  }

  &__input {
    display: none;
  }
}
</style>
